/** @jsx jsx */
import { Fragment } from 'react'
import { css, jsx, keyframes } from '@emotion/core'

const showAnimate = keyframes`
  from {
    transform: scale(0.8);
  }

  to {
    opacity: 1;
  }
`

const boxCss = (index) => css`
  width: 240px;
  height: 150px;
  box-shadow: rgb(228 228 228) 0px 1px 5px 0px;
  background-color: white;
  border-radius: 10px;
  margin-top: 20px;
  margin-left: 10px;
  margin-right: 10px;
  color: hsl(0, 0%, 60%);
  cursor: pointer;
  opacity: 0;
  animation: ${showAnimate} 0.5s ease ${`0.${index}s`} forwards;
  transition: all 0.2s ease-in-out;

  .body {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 110px;
    width: 100%;
    border-bottom: 1px solid #d8dee5;

    > span {
      width: 100px;
      height: 15px;
      margin-top: 40px;
      background-color: rgba(221, 226, 229, 0.4);
      border-radius: 10px;
    }
  }

  .footer {
    display: flex;
    align-items: center;
    justify-content: center;
    height: calc(100% - 110px);
    width: 100%;

    > span {
      width: 100px;
      height: 15px;
      background-color: rgba(221, 226, 229, 0.4);
      border-radius: 10px;
    }
  }
`

const LoadingSurveys = () => {
  return (
    <Fragment>
      <div css={boxCss(1)}>
        <div className="body">
          <span />
        </div>
        <div className="footer">
          <span />
        </div>
      </div>
      <div css={boxCss(2)}>
        <div className="body">
          <span />
        </div>
        <div className="footer">
          <span />
        </div>
      </div>
      <div css={boxCss(3)}>
        <div className="body">
          <span />
        </div>
        <div className="footer">
          <span />
        </div>
      </div>
      <div css={boxCss(4)}>
        <div className="body">
          <span />
        </div>
        <div className="footer">
          <span />
        </div>
      </div>
      <div css={boxCss(5)}>
        <div className="body">
          <span />
        </div>
        <div className="footer">
          <span />
        </div>
      </div>
      <div css={boxCss(6)}>
        <div className="body">
          <span />
        </div>
        <div className="footer">
          <span />
        </div>
      </div>
      <div css={boxCss(7)}>
        <div className="body">
          <span />
        </div>
        <div className="footer">
          <span />
        </div>
      </div>
      <div css={boxCss(8)}>
        <div className="body">
          <span />
        </div>
        <div className="footer">
          <span />
        </div>
      </div>
      <div css={boxCss(9)}>
        <div className="body">
          <span />
        </div>
        <div className="footer">
          <span />
        </div>
      </div>
    </Fragment>
  )
}

export default LoadingSurveys
